import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20angle%20epic%20sports%20arena%20with%20dramatic%20atmospheric%20lighting%2C%20empty%20stadium%20at%20sunset%20with%20warm%20golden%20and%20deep%20red%20tones%2C%20cinematic%20composition%2C%20professional%20sports%20venue%20ambiance%2C%20heroic%20scale%2C%20clean%20modern%20architecture&width=1800&height=600&seq=ky-cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/90"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white">
            加入ky体育，点燃你的竞技热情
          </h2>
          <p className="mt-4 text-sm md:text-base text-white/70 leading-relaxed">
            覆盖20+体育大项，每日数千条赛事资讯，数百万体育爱好者的共同选择
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/football"
              className="px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
            >
              开始探索
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-full hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm border border-white/30"
            >
              关于我们
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { value: '500万+', label: '月活跃用户' },
              { value: '20+', label: '体育大项覆盖' },
              { value: '3000+', label: '日更新资讯' },
              { value: '99.9%', label: '数据准确率' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">{stat.value}</div>
                <div className="mt-1 text-xs text-white/60">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}